module.exports = __webpack_public_path__ + "static/dreams-from-my-father-64dafc9275955c94d8d22c6f3be6e01b.jpg";